module.exports = __webpack_public_path__ + "assets/img/b68089851b614f2d17892d9427486ad9.svg";